/**
 * Native-wrapper concerns, kept out of app/auth logic the same way `pwa.js`
 * keeps the service worker out of it.
 *
 * Everything here is inert in a browser: `initNative()` returns immediately
 * unless we are running inside the Capacitor WebView, and the plugin is pulled
 * in through a **dynamic** import, so the PWA bundle never grows a Capacitor
 * chunk it would only throw away.
 */

import { isNativeWebView } from './platform.js';
import { canGoBack, goBack } from './router.js';

export function initNative() {
  if (!isNativeWebView()) return;

  // Android's hardware/gesture back button. Without a listener the WebView pops
  // its own history, which knows nothing about the router's fallback for a
  // cold start into a sub-screen; with one, "back" means exactly what every
  // in-app back affordance already means. On iOS the event never fires.
  import('@capacitor/app')
    .then(({ App }) => {
      App.addListener('backButton', () => {
        if (canGoBack()) goBack();
        else App.exitApp();
      });
    })
    .catch((err) => console.error('[native] @capacitor/app unavailable:', err));
}
